import React from "react";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import Content from "./components/content";
import Search from "./components/search";
import SearchMarketingActionPlanProvider from "./searchContext";
import WithSidebar from "../../../templates/withSidebar";

const DashboardMarketingActionPlan = () => {
   const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );

  return (
   
      <SearchMarketingActionPlanProvider>
      {/* <Search roleUser={roleUser} /> */}
      <Content roleUser={roleUser} />
      </SearchMarketingActionPlanProvider>
 
   
  );
};

export default DashboardMarketingActionPlan;
